// 📂 components/Client/Table/Menu/MenuTableHeader.tsx
import React from "react";
import { useRole } from "../../../../hooks/useRole";
import { menuGridTemplate } from "./menuTableGrid";

const MenuTableHeader: React.FC = () => {
  const { dropdownOptions } = useRole();
  const roles = dropdownOptions.map((r) => ({
    key: r.code ?? r.name,
    label: r.name,
  }));

  return (
    <div
      className="grid border-b border-stroke bg-gray-2 dark:border-strokedark dark:bg-boxdark-2"
      style={{ gridTemplateColumns: menuGridTemplate(roles.length) }}
    >
      <div className="px-4 py-3 text-left text-sm font-semibold text-black dark:text-white">
        Nombre
      </div>

      {roles.map((role) => (
        <div
          key={role.key}
          className="flex items-center justify-center px-2 py-3 text-center text-xs font-semibold leading-tight text-black dark:text-white"
        >
          {role.label}
        </div>
      ))}

      <div className="px-3 py-3 text-center text-sm font-semibold text-black dark:text-white">
        Orden
      </div>
    </div>
  );
};

export default MenuTableHeader;
